import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  InputSelect,
  RadioGroupActive,
  RadioGroupTab,
  InputText,
} from '@teo/components';
import { selectTrainingType } from '@/components/LearningPath/constants/constantsLearningPaths';
import { round2 } from '@/util';

const backgroundColor = '#EAEAED';
const blurColor = '#C2CDFE';
const focusColor = '#7089FD';

const SettingsTR = ({
  trainingDetail,
  setTypeOfTraining,
  typeOfTraining,
  setTrainingContentLinking,
  trainingContentLinking,
  setMinScore,
  minScore,
  customSettings,
}) => {
  const { t } = useTranslation();
  const [trackColor, setTrackColor] = useState(blurColor);

  const percentageMinScore = round2(minScore ? minScore * 100 : 0);

  const onChangeRadioBox = (value) => {
    setTrainingContentLinking(value);
  };

  return (
    <div>
      <h4 className="mb-1 text-base">
        {t('pages.learning_path.settings_label')}
      </h4>
      {trainingDetail?.inputScore && (
        <div className="mt-5 flex flex-row items-center gap-4 rounded-lg border border-grey-02 p-4">
          <div className="flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:gap-5">
            <p className="min-w-max text-sm">
              {t('pages.course_content_flow.step_3.minimum_score')}
            </p>
            <div className="flex w-full items-center gap-5">
              <input
                className="slider w-full flex-shrink"
                max={100}
                min={0}
                onChange={(e) =>
                  setMinScore(parseFloat(e?.currentTarget.value) / 100)
                }
                onMouseDown={() => setTrackColor(focusColor)}
                onMouseUp={() => setTrackColor(blurColor)}
                onTouchEnd={() => setTrackColor(blurColor)}
                onTouchStart={() => setTrackColor(focusColor)}
                step={5}
                style={{
                  background: `linear-gradient(to right, ${trackColor} 0%, ${trackColor} ${percentageMinScore}%, ${backgroundColor} ${percentageMinScore}%, ${backgroundColor})`,
                }}
                value={percentageMinScore}
                type="range"
                disabled={!trainingDetail?.inputScore}
              />
              <InputText
                type="number"
                value={percentageMinScore}
                onChange={(e) =>
                  setMinScore(parseFloat(e?.currentTarget.value) / 100)
                }
                suffix="%"
                className="w-[90px]"
                disabled={!trainingDetail?.inputScore}
              />
            </div>
          </div>
        </div>
      )}
      {trainingDetail?.trainingType === 'training' && (
        <>
          <div className="mt-5">
            <label className="mb-1 block text-sm font-semibold text-black">
              {t('pages.learning_path.settings.training_type')}
            </label>
            <InputSelect
              value={{
                id: 0,
                value: typeOfTraining,
                name: typeOfTraining,
              }}
              onChange={(value) => {
                setTypeOfTraining(value?.value);
              }}
              options={selectTrainingType}
              disabled={!customSettings}
            >
              {(options) => (
                <span>
                  {options &&
                    t(`pages.learning_path.settings.type_tr_${options?.name}`)}
                </span>
              )}
            </InputSelect>
          </div>
          {typeOfTraining === 'online' && (
            <div className="mt-5">
              <label className="mb-1 block text-sm font-semibold text-black">
                {t('pages.learning_path.settings.content_linking')}
              </label>
              <RadioGroupActive
                onChange={onChangeRadioBox}
                value={trainingContentLinking}
                gap="gap-2"
                disabled={!customSettings}
              >
                <RadioGroupActive.Option value="URL" hiddenRadio>
                  {t('pages.learning_path.settings.url')}
                </RadioGroupActive.Option>
                <RadioGroupActive.Option value="LTI" hiddenRadio>
                  {t('pages.learning_path.settings.lti')}
                </RadioGroupActive.Option>
                <RadioGroupActive.Option value="xAPI" hiddenRadio>
                  {t('pages.learning_path.settings.xapi')}
                </RadioGroupActive.Option>
              </RadioGroupActive>
            </div>
          )}
        </>
      )}
      {trainingDetail?.trainingType === 'evaluation' && (
        <>
          <div className="mt-5">
            <label className="mb-1 block text-sm font-semibold text-black">
              {t('pages.learning_path.settings.evaluation_type')}
            </label>
            <RadioGroupTab
              onChange={(value) => {
                setTypeOfTraining(value);
              }}
              value={typeOfTraining}
              classBody="bg-grey-02 !p-0.5"
              disabled={!customSettings}
            >
              <div className="flex w-full flex-row gap-0.5">
                <div className={`basis-1/2 rounded-lg`}>
                  <RadioGroupTab.Option
                    value="internal"
                    hiddenRadio
                    checkedClassName="bg-primary-04"
                    className="!block !p-2 text-center"
                    disabled={!customSettings}
                  >
                    <span className="text-sm font-medium text-grey-09">
                      {t('pages.learning_path.settings.internal')}
                    </span>
                  </RadioGroupTab.Option>
                </div>
                <div className={`basis-1/2 rounded-lg `}>
                  <RadioGroupTab.Option
                    value="external"
                    hiddenRadio
                    checkedClassName="bg-primary-04"
                    className="!block !p-2 text-center"
                    disabled={!customSettings}
                  >
                    <span className="text-sm font-medium text-grey-09">
                      {t('pages.learning_path.settings.external')}
                    </span>
                  </RadioGroupTab.Option>
                </div>
              </div>
            </RadioGroupTab>
          </div>
        </>
      )}
    </div>
  );
};
export default SettingsTR;
